<div class="flex flex-col justify-center px-3 md:px-4 gap-3">
  @if (questionItems().length > 0) {
    @for (item of questionItems(); track $index) {
      <app-shared-card additionalClasses="p-3 md:p-4">
        <app-accordion
          [title]="item.question"
          [isInitiallyOpen]="item.important"
        >
          <div class="font-normal text-[15px] text-neutral-500" [innerHTML]="item.answer | enforceNewLine"></div>
        </app-accordion>
      </app-shared-card>
    }
  } @else {
    <app-shared-card additionalClasses="p-3 md:p-4">
      <div class="w-full font-medium text-gray-800">Hier gibt's bald Antworten</div>
      <div class="font-normal text-[15px] text-neutral-500 pt-3">Sobald Fragen zum Event eingehen, findest du die Antworten an dieser Stelle.</div>
    </app-shared-card>
  }
</div>
